import apiClient from './client';

let keycloakInstance = null;

export const initializeInterceptors = (keycloak) => {
    keycloakInstance = keycloak;

    apiClient.interceptors.request.use(
        async (config) => {
            if (!keycloakInstance?.authenticated) {
                await new Promise((resolve) => {
                    const interval = setInterval(() => {
                        if (keycloakInstance?.authenticated) {
                            clearInterval(interval);
                            resolve();
                        }
                    }, 50);
                });
            }

            try {
                await keycloakInstance.updateToken(30);
            } catch (error) {
                keycloakInstance.login();
            }

            config.headers.Authorization = `Bearer ${keycloakInstance.token}`;
            return config;
        },
        (error) => Promise.reject(error)
    );
};

export const getKeycloak = () => keycloakInstance;